<bfx-text-input
  #textInput
  [bfxTooltip]="data.errorMsg ? data.errorMsg : null"
  tooltipPosition="top"
  tooltipStyleClass="bfx-tooltip-negative-bold"
  [inputLabelText]="label"
  [size]="'sm'"
  pInputText
  [maxLength]="config.maxLength"
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  [(ngModel)]="data.text"
  class="icd__label__input"
  [disabled]="true"
  [externalState]="data.state"
  type="search"
  autocomplete="off"
>
</bfx-text-input>
